import React from 'react'

export default function UpdateMaintenanceSchedule() {
  return (
    <div className='main'>UpdateMaintenanceSchedule</div>
  )
}
